/* created by Athukorala */

import * as actionTypes from "./actionTypes";

export const spinnerHandler = (data) => {

  return {
    type: actionTypes.SPINNER,
    value: data
  }
};
